import { Button, Popconfirm, Divider, Form, Input, List, message, Select, Space, Tooltip } from 'antd';
import React, { useEffect, useState } from 'react';
import {
	MinusCircleOutlined,
	PlusOutlined,
} from "@ant-design/icons";
import { useListVals } from "../../Firebase/databaseHooks";
import { getDatabase, ref, update, remove } from "firebase/database";
import Firebase from "../../Firebase/Firebase";
import { Label } from "evergreen-ui";
import { MDBIcon } from "mdbreact";
import FireFetch from "../../Firebase/FireFetch";
import ReactDragListView from "react-drag-listview";
import { useParams } from 'react-router-dom';

const IconText = ({ icon, text }) => (
	<Space>
		{React.createElement(icon)}
		{text}
	</Space>
);
const { TextArea } = Input;
var db = getDatabase(Firebase);

const QuestionList = (props) => {
	const { id } = useParams();
	const canUpdateQuiz = Boolean(props.canUpdateQuiz);
	const canDeleteQuiz = Boolean(props.canDeleteQuiz);
	const [questions, loading] = useListVals(ref(db, `talmidsdb/quizzes/${id}/questions`));
	const [questionArray, setQuestionArray] = useState([]);
	const [fieldArray, setFieldArray] = useState([]);
	const [currentID, setCurrentID] = useState(null);
	const [editID, setEditID] = useState(null)

	useEffect(() => {
		if (questions) {
			var fields = [];
			questions.forEach((x, index) => {
				if (!x) return;
				fields.push(
					{
						"name": [x.id],
						"value": x.question
					});
				if (x.options != null || x.options !== undefined) {
					Object.keys(x.options)?.map((key, index) => {
						fields.push(
							{
								"name": [x.id + "-" + index],
								"value": x.options[key]
							}
						)
					});
				}
				fields.push(
					{
						"name": [x.id + "-answer"],
						"value": x.answer
					});

			});
			setFieldArray([...fields]);
			setQuestionArray([...questions.filter(Boolean).sort((a, b) => a.questionIndex - b.questionIndex)]);
		}
	}, [props.quizID, questions]);

	const editQuestions = (values) => {
		if (!canUpdateQuiz) {
			message.error("You do not have permission to edit quiz questions.");
			return;
		}

		var question = questionArray.find(x => x.id === editID);
		question.question = values[question.id];
		question.answer = values[question.id + "-answer"]
		var array = [];
		question.options.map((x, index) => {
			array.push(values[question.id + "-" + index]);
		});
		question.options = array;

		update(ref(db, `talmidsdb/quizzes/${id}/questions/` + question.id), question)
			.then((result) => {
				FireFetch.addLog(`talmidsdb/quizzes/${id}/questions`, question.id, "Edit");
				message.success("question edited successfully");
			})
			.catch((error) => {
				message.error(`Unable to edit question. An error occurred : ${error.message}`);
			})
	}

	const onDragEnd = (fromIndex, toIndex) => {
		if (!canUpdateQuiz) {
			message.error("You do not have permission to reorder quiz questions.");
			return;
		}

		if (toIndex < 0) return;
		const items = [...questionArray];
		const item = items.splice(fromIndex, 1)[0];
		items.splice(toIndex, 0, item);
		items.map((item, index) => {
			item.questionIndex = index;
		});
		setQuestionArray([...items]);
		items.map((item) => {
			update(ref(db, `talmidsdb/quizzes/${id}/questions/` + item.id), item)
		});
	};

	return (
		<>
			<ReactDragListView
				nodeSelector=".ant-list-item.draggable-item"
				onDragEnd={onDragEnd}
			>
				<List
					itemLayout="vertical"
					loading={loading}
					dataSource={questionArray}
					renderItem={(field, index) => (
						<List.Item
							className="draggable-item"
							key={field.id}
							actions={[
								canUpdateQuiz ? (
									<Button onClick={() => {
										setCurrentID(field.id);
										setEditID(field?.id);
										var question = questionArray.find(x => x?.id === field?.id);
										question.options.push("");
										var tArray = questionArray;
										tArray[tArray.findIndex(x => x.id === field.id)] = question;
										setQuestionArray([...tArray]);
										//update(ref(db, "talmidsdb/QuizQuestions/"+question.questionID), question)
									}}>
										<IconText icon={PlusOutlined} text="Add Option" key="list-vertical-star-o" />
									</Button>
								) : null
								,
							]}
							extra={
								<div>
									{canUpdateQuiz ? (
										currentID !== field.id ?
											<Tooltip title="Edit question">
												<Button
													type="primary"
													className="mx-1"
													width={200}
													htmlType="submit"
													form={"Form=" + field.id}
													onClick={() => {
														setCurrentID(field.id);
														setEditID(field.id);
													}}
												>
													<MDBIcon icon="pen" />
												</Button>
											</Tooltip>
											:
											<Tooltip title="save edits">
												<Button
													type="primary"
													className="mx-1"
													width={200}
													onClick={() => {
														setCurrentID("field?.id");
													}}
												>
													<MDBIcon icon="check" />
												</Button>
											</Tooltip>
									) : null}
									{canDeleteQuiz && (
										<Tooltip title="delete question">
											<Popconfirm
												title={`Are you sure you want to delete this question?${field.id}`}
												onConfirm={() => {
													if (!canDeleteQuiz) {
														message.error("You do not have permission to delete quiz questions.");
														return;
													}

													remove(ref(db, `talmidsdb/quizzes/${id}/questions/${field.id}`)).then(() => {
														message.info("Question deleted successfully");
													});
												}}
												okText="Yes"
												cancelText="No"
												color="red"
											>
												<Button
													type="danger"
													className="mx-1"
													width={200}
												>
													<MDBIcon icon="trash" />
												</Button>
											</Popconfirm>
										</Tooltip>
									)}
								</div>
							}
						>
							<div
								className="grabbable"
								style={{ cursor: "pointer" }}>
								<Divider orientation="left" className="font-weight-bolder">{"Question " + (index + 1)}</Divider>
								<Form
									layout="vertical"
									id={"Form=" + field.id}
									onFinish={editQuestions}
									fields={fieldArray}
								>
									<Form.Item label={"Question " + (index + 1)}
										name={field.name}
										rules={[{ required: true }]}
									>
										<TextArea disabled={currentID !== field.id} placeholder={"enter question"} value={field.question} id={field.id} />
									</Form.Item>
									<Label>
										Options
									</Label>
									{field.options ? (Object.keys(field.options)).map((key, index) => (
										<>
											<Form.Item
												required={false}
											//key={field?.id+"-"+key}
											>
												<Form.Item
													name={field.id + "-" + index}
													validateTrigger={['onChange', 'onBlur']}
													rules={[
														{
															required: true,
															whitespace: true,
															message: "Please input option text",
														},
													]}
													noStyle
												>
													<Input
														placeholder="enter option text"
														disabled={currentID !== field.id}
														id={field?.id + "-" + index}
														style={{
															width: '94%',
														}}
													/>
												</Form.Item>
												{canUpdateQuiz && questionArray.length > 0 ? (
													<Tooltip title="Remove option">
														<Button type="danger"
															shape="circle"
															icon={<MinusCircleOutlined />}
															className="dynamic-delete-button mx-2"
															onClick={() => {
																setCurrentID(field?.id);
																setEditID(field?.id);
																var question = questionArray.find(x => x.questionID === field?.id);
																question.options.splice(index, 1);
																var tArray = questionArray;
																tArray[tArray.findIndex(x => x.questionID === field?.id)] = question;
																setQuestionArray([...tArray]);
																update(ref(db, `talmidsdb/quizzes/${id}/questions/` + question.questionID), question)
															}} />
													</Tooltip>
												) : null}
											</Form.Item>
										</>
									)) : null}
									<Form.Item label="Correct Answer"
										name={field?.id + "-answer"}
										rules={[
											{
												required: true,
												message: "Please input correct answer",
											},
										]}
									>
										<Select
											disabled={currentID !== field?.id}
											placeholder="Select correct option"
											id={field?.id + "-answer"}
										>
											{field.options ? (Object.keys(field.options)).map((key, index) => {
												return (
													<Select.Option key={index} value={index}>{`option-${parseInt(key) + 1}`}</Select.Option>
												)
											}) : null}
										</Select>
									</Form.Item>
								</Form>
							</div>
						</List.Item>
					)}
				/>
			</ReactDragListView>
		</>
	)
}

export default QuestionList;
